import React, { useState, useEffect } from "react"
import CardGroup from "react-bootstrap/CardGroup"
import Card from "react-bootstrap/Card"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import Alert from "react-bootstrap/Alert"

import "../recipes/recipesCard.css"
import QuickView from "../recipes/QuickView"

function RecipesCards({ recipes, totalResults, deleteFav }) {
  const [show, setShow] = useState(false)
  const [quickRecipe, setQuickRecipe] = useState()

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const getRecipe = (recipe) => {
    setQuickRecipe(recipe)
  }

  return (
    <>
      <div className='alerts-div'>
        <h1 className='mt-5 mr-2 recipes-title'>Favorites</h1>
        <Alert className='mt-4 alert text-center alert-inline '>
          {totalResults === 1
            ? totalResults + " Favorite"
            : totalResults + " Favorites"}
        </Alert>
      </div>

      <CardGroup className='cardGroup'>
        <Row xs={1} sm={3} lg={4} className='d-flex justify-content-center '>
          {recipes.map((recipe) => {
            return (
              <Card key={recipe.id} className='cardsContainer mx-2 mt-4'>
                <Card.Img
                  variant='top'
                  src={recipe.image}
                  className='card-img'
                />
                <Card.Body className='card-body'>
                  <Card.Title>{recipe.title}</Card.Title>
                </Card.Body>
                <div className='card-footer d-flex justify-content-between'>
                  <Button
                    className='myBtn'
                    onClick={(e) => {
                      handleShow()
                      getRecipe(recipe)
                      e.currentTarget.blur()
                    }}>
                    Quick view
                  </Button>
                </div>
              </Card>
            )
          })}
        </Row>
      </CardGroup>
      {quickRecipe && (
        <QuickView
          show={show}
          handleClose={handleClose}
          recipe={quickRecipe}
          favoritesCard={true}
          deleteFav={deleteFav}></QuickView>
      )}
    </>
  )
}

export default RecipesCards
